import { css } from '@emotion/core';
import styled from '@emotion/styled';
import ErrorCard from 'components/Kizen/ErrorCard';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';
import { borderRadii, resetButtonCss } from 'app/spacing';
import { IconSizing } from '__components/Kizen/Icon';

export const StyleErrorCard = styled(ErrorCard)`
  position: absolute;
  left: 0;
  top: 100%;
  max-width: 100%;
  width: 100%;
`;

export const StyledPlaceholder = styled.div<{ error?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;

  span {
    color: var(--color-font-placeholder);
  }

  & > span {
    margin-top: 9px;
    margin-bottom: 3px;
  }

  ${({ error }) =>
    error &&
    css`
      & > span {
        color: var(--color-button-warning-hover);
      }
    `}

  div {
    margin-top: 12px;

    & span:first-child {
      color: var(--color-button-secondary-default);

      &:hover {
        color: var(--color-button-secondary-hover);
      }
    }
  }
`;

export const ChooserDragAndDrop = styled.button<{
  multiFileMode?: boolean;
  isMobile?: boolean;
  status?: boolean;
  error?: boolean;
  disabled?: boolean;
  focused?: boolean;
}>`
  ${({ multiFileMode, isMobile }) =>
    multiFileMode
      ? css`
          ${resetButtonCss({ keepBorder: true })}
          display: flex;
          flex: 0 0 ${isMobile ? 105 : 164}px;
          flex-direction: column;
          min-width: 1px;
          width: 100%;
          border-radius: ${borderRadii.small};
          cursor: pointer;
          justify-content: center;
          align-items: center;
          position: relative;
        `
      : css`
          && {
            background-color: var(--color-background-white);
            padding: 13px 15px 18px;
            font: inherit;
            cursor: pointer;
            outline: none;
          }
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius: ${borderRadii.small};
          width: 100%;
        `};

  ${({ status, multiFileMode }) =>
    status &&
    multiFileMode &&
    css`
      border: solid 1px var(--color-button-secondary-hover);
    `}

  ${({ disabled, multiFileMode, focused }) =>
    disabled
      ? css`
          cursor: default;
        `
      : css`
          &:hover {
            ${(!multiFileMode || focused) &&
            css`
              && i {
                color: var(--color-background-darker);
              }
            `}
          }
        `}

  ${({ focused }) =>
    focused &&
    css`
      && i {
        color: var(--color-background-darker);
      }
    `}
`;

export const LoadingBar = styled.div<{ multiFileMode?: boolean }>`
  height: 43px;
  ${({ multiFileMode }) =>
    !multiFileMode &&
    css`
      height: 42px;
    `}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const CloudIcon = styled(IconSizing)`
  margin-bottom: -${(50 - 35) / 2}px; // because <SizeIcon />> is square remove a little bottom margin
`;

export const SpacedTypography = styled.div<{ singleMode?: boolean }>`
  ${({ singleMode }) =>
    singleMode
      ? css`
          margin-top: 12px;
        `
      : css`
          margin-top: 19px;
        `}
`;

export const ErrorSpacedTypography = styled.div`
  margin-top: 7px;
`;

export const ErrorFileTypography = styled(TextEllipsisWithTooltip)`
  margin-top: 4px;
`;
